import ChartType from '@opsbase/lib-chart/ChartType/ChartType';
import ChartVariant from '@opsbase/lib-chart/ChartVariant/ChartVariant';
import OpDataSchema from '@opsbase/lib-data-metamodel/metamodels/OpMetaModel';
import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import View from '@opsbase/lib-data-view/View';
import ViewFieldKey from '@opsbase/lib-data-viewfield/ViewFieldKey';
import ViewFieldRegistry from '@opsbase/lib-data-viewfield/ViewFieldRegistry';
import getViewFieldsFromQuestions from '@opsbase/lib-form/helpers/getViewFieldsFromQuestions';
import GradingMethodType from '@opsbase/lib-grading/GradingMethodType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import usePopDefinitionFindById from '@opsbase/react-gql-hooks/popdefinition/usePopDefinitionFindById';
import useSysLang from '@opsbase/web-ctrl-syslang/SysLangController/useSysLang';
import useViewRegistry from '@opsbase/web-ctrl-view/useViewRegistry';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import DVLPage from '@opsbase/web-dvl-page';
import Vertical from '@opsbase/web-layout/Vertical';
import Spinner from '@opsbase/web-ui/Spinner/Spinner';
import Text from '@opsbase/web-ui/Text/Text';
import React, { useEffect } from 'react';
import OpsSelectionToolbar from '../../toolbars/OpsSelectionToolbar';
export function OpDefinitionEditHistoryTab(props) {
    const { opDefinition, editable } = props;
    const viewRegistry = useViewRegistry();
    const { putView } = useViewRegistryActions();
    const { loading, data: popDefinition } = usePopDefinitionFindById({
        variables: { id: opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.latestPublishedOpDefinitionId },
        skip: !(opDefinition === null || opDefinition === void 0 ? void 0 : opDefinition.latestPublishedOpDefinitionId),
    });
    const viewId = 'opsfor' + (popDefinition === null || popDefinition === void 0 ? void 0 : popDefinition.id);
    const { language } = useSysLang();
    useEffect(() => {
        var _a, _b;
        if (popDefinition && !viewRegistry[viewId]) {
            const allops = viewRegistry['allops'];
            const view = new View({
                id: viewId,
                title: allops.title,
                type: allops.type,
                fields: allops.fields,
                groupBys: [],
                filters: [],
                sortBy: allops.sortBy.key,
                sortByDesc: allops.sortByDesc,
            });
            // If OpDef Log
            if (popDefinition) {
                view.filters.push({
                    queryFieldKey: QueryFieldKey.OPDEFINITION,
                    id: popDefinition.opDefinitionId,
                    title: popDefinition.title,
                    hidden: true,
                    veryHidden: true,
                });
                const opFields = OpDataSchema.fields;
                view.fields = [
                    ViewFieldRegistry[ViewFieldKey.ROWKEY],
                    opFields.find(ff => ff.key === ViewFieldKey.OP_STARTFROM),
                    opFields.find(ff => ff.key === ViewFieldKey.OP_STATUS),
                ];
                if (popDefinition.isScoreEnabled) {
                    view.fields.push(opFields.find(ff => ff.key === ViewFieldKey.OP_SCORE));
                }
                if (((_a = popDefinition.gradingMethod) === null || _a === void 0 ? void 0 : _a.gradingMethodType) !== GradingMethodType.NONE) {
                    view.fields.push(opFields.find(ff => ff.key === ViewFieldKey.OP_PASSSTATUS));
                }
                if (((_b = popDefinition.gradingMethod) === null || _b === void 0 ? void 0 : _b.gradingMethodType) === GradingMethodType.CALCULATED) {
                    view.fields.push(opFields.find(ff => ff.key === ViewFieldKey.OP_GRADE));
                }
                view.fields = [
                    ...view.fields,
                    ...getViewFieldsFromQuestions(popDefinition.form, language),
                ];
                view.chartBox = { visible: false, charts: [] };
                if (popDefinition.isScoreEnabled) {
                    view.chartBox.visible = true;
                    view.chartBox.charts = [
                        {
                            key: 'scoreChart',
                            chartType: ChartType.BAR3DSTACK,
                            chartVariant: ChartVariant.SCORE_Q_OP,
                            config: {},
                        },
                    ];
                }
            }
            putView(view, true);
        }
    }, [viewId, viewRegistry, popDefinition, putView, language]);
    if (!popDefinition)
        return (React.createElement(Vertical, { padding: true },
            React.createElement(Text, null, i18n.t('no-data-until-performed'))));
    return (React.createElement(Vertical, null,
        loading && React.createElement(Spinner, null),
        !loading && (React.createElement(DVLPage, { key: "opslog", padding: "4px 16px", viewId: viewId, itemPage: Pages.OP_VIEW, itemDeletePage: Pages.OP_DELETE, notFoundText: i18n.t('no-ops-found'), disableSaving: true, disableOpsMenu: true, itemSelectionToolbar: React.createElement(OpsSelectionToolbar, { editable: editable }) }))));
}
export default OpDefinitionEditHistoryTab;
